import * as miljoRettelserActions from "../actions/miljoRettelserActions";

const INITIAL_STATE = [];

export default function miljoRettelserReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case miljoRettelserActions.GET_MILJO_RETTELSER_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
